import * as React from 'react';
import './index.scss';
import { requestComments, addComment, requestAddComment } from '../../model/api';
import dateFormat from 'dateformat';
import { Button, message, Modal, Input, Checkbox, Pagination, Spin } from 'antd';

const { TextArea } = Input;

export default class Comments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      comments: [],
      showInput: false,
      text: "",
      anonymous: false,
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      loading: false,
    }

    this.requestComments = this.requestComments.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  componentDidMount() {
    setTimeout(() => this.requestComments(), 1000);
  }

  async requestComments(init = true) {
    try {
      this.setState({ loading: true })
      const { pageIndex, pageSize } = this.state
      const res = await requestComments(this.props.ckey, pageIndex, pageSize)
      const data = res.data
      // .then(data => {
        console.log("comment data=", data, '2025-04-17')
      if (res.code == 0) {
        this.setState({ comments: data.comments, pageTotal: data.total || 0 });
        if (!init) {
          message.info("吐槽已更新");
        }
      }
      // })
    } catch (err) {
      console.log("err=", err)
    } finally {
      this.setState({ loading: false })
    }
  }

  getDate(date) {
    date = date.replace(' ', 'T') + "+00:00";
    return dateFormat(new Date(date), "yyyy-mm-dd HH:MM:ss");
  }

  handleInput() {
    if(!this.state.text) {
      message.error("您还没有吐槽任何内容...");
    }else {
      requestAddComment(this.state.text, this.state.anonymous).then(data => {
        this.setState({ showInput: false, pageIndex: 1 }, () => {
          this.requestComments(false);
        });
      })
    }
  }

  pageChange = (page, pageSize) => {
    console.log("page, size=", page, pageSize)
    this.setState({ pageIndex: page, pageSize }, () => {
      this.requestComments()
    })
  }

  refresh = () => {
    this.setState({ pageIndex: 1 }, () => {
      this.requestComments(false)
    })
  }

  render() {
    const { comments, pageIndex, pageSize, pageTotal, loading } = this.state;
    return (
      <div className='comments'>
        <div>
          <Button className='comments-add' onClick={() => this.setState({showInput: true})}>我要吐槽</Button>
          <div className='comments-title'>吐槽广场<div className='comments-fresh' onClick={this.refresh}>刷新</div></div>
          <Spin spinning={loading} indicator={<></>} tip="">
          {!!comments.length && comments.map((comment, i) => {
            return (
              <div className='comments-item' key={i}>
                <div className='comments-item-title'>
                  <div className='comments-item-avatar'><img src={(!comment.anonymous && comment.user_avatar) || "https://originalstatic.aminer.cn/misc/ncov/homepage/avatars/default.jpg"} /></div>
                  <div className='comments-item-name'>{(!comment.anonymous && comment.user_nickname || comment.user_name) || "一位不愿透露姓名的朋友"}</div>
                </div>
                <div className='comments-item-text'>{comment.text}</div>
                <div className='comments-item-date'>{this.getDate(comment.createTime)}</div>
              </div>
            )
          })}
          {pageTotal > 0 && <div className='comments-page'>
            <Pagination size="small" current={pageIndex} pageSize={pageSize} total={pageTotal} onChange={this.pageChange} showSizeChanger={false} />
          </div>}
          </Spin>
          {/* <Button className='comments-add' onClick={() => this.setState({showInput: true})}>我要吐槽</Button> */}
        </div>
        <Modal
          title="吐槽"
          visible={this.state.showInput}
          okText="提交"
          cancelText="取消"
          onOk={this.handleInput}
          onCancel={() => this.setState({showInput: false})}
        >
          <Checkbox className='comments-anonymous' checked={this.state.anonymous} onChange={e => this.setState({anonymous: e.target.checked})}>匿名吐槽</Checkbox>
          <TextArea className='comments-input' placeholder='一吐为快' value={this.state.text} onChange={e => this.setState({text: e.target.value})}/>
        </Modal>
      </div>
    )
  }
}